import { create } from 'zustand/index';
import { ParsedFragmentEntity } from '@entities/ParsedFragment/Types';
import {
    ViewItemTypesModeEnum,
    ViewItemTypesModeType,
} from '@modules/Steps/Shared/Enums/ViewItemTypesModeEnum';
import { ItemTypeEntity, RawItemType } from '@entities/ItemType/Types';
import { GalleryEntity } from '@entities/Gallery/Types';
import { RawItem } from '@entities/Item/Types';
import { PaginationResponse } from '@shared/Interfaces/Api/Pagination';

interface AllItemsTypesItemsData {
    data: RawItem[];
    pagination: PaginationResponse;
}

export interface RawItemTypeWithItems extends Omit<RawItemType, 'items'> {
    items: AllItemsTypesItemsData;
}

export interface State {
    parsedFragments: ParsedFragmentEntity[];
    fragmentsViewMode: ViewItemTypesModeType;
    laborItemTypes: ItemTypeEntity[];
    toolItemTypes: ItemTypeEntity[];
    fragmentsWithMaterialItemTypes: ParsedFragmentEntity[];
    itemTypesWithItems: RawItemTypeWithItems[];
    galleryData: GalleryEntity[];

    fragmentsLoading: boolean;

    isMinimumPriceLoading: boolean;
    isResetProjectLoading: boolean;
    isFragmentsUpdateLoading: boolean;
}

export interface Actions {
    setParsedFragments: (newParsedFragments: ParsedFragmentEntity[]) => void;
    setLaborItemTypes: (newLaborItemTypes: ItemTypeEntity[]) => void;
    setToolItemTypes: (newToolItemTypes: ItemTypeEntity[]) => void;
    setFragmentsWithMaterialItemTypes: (
        newFragmentsWithMaterialItemTypes: ParsedFragmentEntity[]
    ) => void;
    setGalleryData: (newGalleryData: GalleryEntity[]) => void;
    setFragmentsViewMode: (newFragmentsViewMode: ViewItemTypesModeType) => void;
    setItemTypesWithItems: (
        newItemTypesWithItems: RawItemTypeWithItems[]
    ) => void;

    setIsMinimumPriceLoading: (isLoading: boolean) => void;
    setIsResetProjectLoading: (isLoading: boolean) => void;
    setIsFragmentsUpdateLoading: (isLoading: boolean) => void;
}

export const useFragmentsStore = create<State & Actions>((set, get) => ({
    parsedFragments: [],
    fragmentsViewMode: ViewItemTypesModeEnum.WorkStage,
    laborItemTypes: [],
    toolItemTypes: [],
    fragmentsWithMaterialItemTypes: [],
    galleryData: [],
    itemTypesWithItems: [],
    fragmentsLoading: false,

    isMinimumPriceLoading: false,
    isResetProjectLoading: false,
    isFragmentsUpdateLoading: false,

    setParsedFragments: (newParsedFragments: ParsedFragmentEntity[]) => {
        set({ parsedFragments: newParsedFragments });
    },

    setLaborItemTypes: (newLaborItemTypes: ItemTypeEntity[]) => {
        set({ laborItemTypes: newLaborItemTypes });
    },
    setToolItemTypes: (newToolItemTypes: ItemTypeEntity[]) => {
        set({ toolItemTypes: newToolItemTypes });
    },
    setFragmentsWithMaterialItemTypes: (
        newFragmentsWithMaterialItemTypes: ParsedFragmentEntity[]
    ) => {
        set({
            fragmentsWithMaterialItemTypes: newFragmentsWithMaterialItemTypes,
        });
    },
    setGalleryData: (newGalleryData: GalleryEntity[]) => {
        set({ galleryData: newGalleryData });
    },
    setFragmentsViewMode: (newFragmentsViewMode: ViewItemTypesModeType) => {
        set({ fragmentsViewMode: newFragmentsViewMode });
    },
    setItemTypesWithItems: (newItemTypesWithItems: RawItemTypeWithItems[]) => {
        set({ itemTypesWithItems: newItemTypesWithItems });
    },

    setIsMinimumPriceLoading: (isLoading: boolean) => {
        set({ isMinimumPriceLoading: isLoading });
    },
    setIsResetProjectLoading: (isLoading: boolean) => {
        set({ isResetProjectLoading: isLoading });
    },
    setIsFragmentsUpdateLoading: (isLoading: boolean) => {
        set({ isFragmentsUpdateLoading: isLoading });
    },
}));
